export default __webpack_public_path__ + "static/literary-analysis-d6ba51a4aa30f1e06e7d22dde199aee5.png";